import {SagaIterator} from 'redux-saga';
import {put} from 'redux-saga/effects';

import {setLoadingSavePayment} from '../../../reducers/paymentStep/savePaymentData/savePaymentData';

/**
 * Set loading payment step
 * @param {boolean} isLoading - is loading step
 */
export function* setLoadingSavePaymentSaga(isLoading: boolean): SagaIterator {
    yield put(setLoadingSavePayment(isLoading));
}
